<script>
import { Line, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
	name: 'commission-chart',
	extends: Line,
	mixins: [reactiveProp],
	props: ['chartId', 'options'],
	mounted() {
		this.renderChart(this.chartData, this.options);
	},
};
</script>
